import { LogLevel, PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID || "",
        authority: "https://login.microsoftonline.com/5b44bfa6-47bc-4638-8409-a21d403f820a",
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (logLevel: any, message: any, containsPii: any) => {
                if (!containsPii) {
                    // console.log("[MSAL]", message);
                }
            },
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false,
        },
    },
};



// Used when acquiring a token
export const loginRequest = {
    scopes: ["openid", "profile"],
};
export const msalInstance = new PublicClientApplication(msalConfig);